import React, { useState } from "react";
import Certificate from "./Certificate";
import Education from "./Education";
import Experience from "./Experience";
import { MuiPickersUtilsProvider } from "@material-ui/pickers";
import JalaliUtils from "@date-io/jalaali";
import StyledButton from "../../../../../UIcomponent/Button";
import ProfileReq from "../../../../../Utility/Requester/ProfileReq";
import { Notify } from "../../../../../UIcomponent/NotificationManager";

function Resume(props) {
  const { resume } = props;
  const [data, setData] = useState(resume);
  const url = resume?.isCreate ? "CreateTeacherResume" : "UpdateTeacherResume";

  const onSave = () => {
    const newData = {
      Resume: {
        ...data,
      },
    };

    delete newData.Resume.isCreate;

    ProfileReq[url](newData)
      .then((res) => {
        if (resume?.isCreate) {
          resume.isCreate = false;
        }
        Notify("success", "اطلاعات با موفقیت ذخیره شد.", 3000);
      })
      .catch(() => {
        Notify("error", "خطا در ذخیره سازی اطلاعات، دوباره تلاش کنید.", 3000);
      });
  };

  return (
    <div>
      <div className="title-bar">
        <h3>رزومه</h3>
      </div>
      <MuiPickersUtilsProvider utils={JalaliUtils} locale="fa">
        <Certificate
          moveData={(data) => setData({ ...resume, certificate: data })}
          certificates={resume.certificate}
        />
        <Education
          moveData={(data) => setData({ ...resume, education: data })}
          educations={resume.education}
        />
        <Experience
          moveData={(data) => setData({ ...resume, experience: data })}
          experiences={resume.experience}
        />
        <br />
        <StyledButton onClick={onSave} style={{ marginRight: "auto" }} primary>
          ذخیره
        </StyledButton>
      </MuiPickersUtilsProvider>
    </div>
  );
}

export default Resume;
